export const OperationMethodData = `
  id
  name
  code
`;
